export default __webpack_public_path__ + "static/media/2.567ab552.jpg";